module.exports = __webpack_public_path__ + "static/img/guidance-robote.748e463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guidance-robote.png
// module id = oyIL
// module chunks = 99